<template>
  <div>
    <div class="pt-2">
      <table class="width-100">
        <tr>
          <th colspan="2" class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1">
            Cancellation Charges
          </th>
        </tr>
        <tr>
          <td class="font-size-18 font-weight-500 py-1" valign="top">
            Terms and Condition
          </td>
          <td class="font-size-18 py-1">
            <span v-if="detail && detail.terms_and_condition" v-html="detail.terms_and_condition"></span>
            <em v-else class="text-muted"> no terms and condition </em>
          </td>
        </tr>
        <tr>
          <td class="font-size-18 font-weight-500 py-1" width="150">
            Days Without Penalty
          </td>
          <td class="font-size-18 py-1">
            <span v-if="detail && detail.no_penalty_cancel_days">
              <v-chip small label color="chip-custom-blue" outlined class="text-white">{{ detail.no_penalty_cancel_days
              }}</v-chip>
            </span>
            <em v-else class="text-muted"> no days </em>
          </td>
        </tr>
      </table>
    </div>
    <ListingTable :columnCount="5">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">#</th>
            <th class="simple-table-th">Charge Duration</th>
            <th class="simple-table-th">Charge</th>
            <th class="simple-table-th">Charge Type</th>
          </tr>
        </thead>
      </template>
      <template v-slot:tbody>
        <tbody class="custom-border-bottom">
          <template v-if="charges?.length > 0">
            <tr class="alternate-listing-row" v-for="(row, index) in charges" :key="index">
              <td class="simple-table-td">{{ index + 1 }}</td>
              <td class="simple-table-td">{{ row?.charge_duration }}</td>
              <td class="simple-table-td">{{ row?.charge }}</td>
              <td class="simple-table-td">{{ row?.charge_type }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="4" class="py-4">
              <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no charges available at the moment.
              </p>
            </td>
          </tr>
        </tbody>
      </template>
    </ListingTable>
  </div>
</template>
<script>
import { GET } from "@/core/services/store/request.module";

import ListingTable from "@/view/pages/partials/Listing-Table.vue";
export default {
  data() {
    return {
      charges: [],
    };
  },
  props: {
    service_id: {
      type: String,
      default: null,
      required: false,
    },
    detail:
    {
      type: Object,
      default: null,
      required: false,
    },
  },
  components: {
    ListingTable,
  },
  methods: {
    getCharges() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "get-charges/" + _this.service_id,
        })
        .then(({ data }) => {
          _this.charges = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  created() {
    this.service_id = this.$route.params?.id;
    setTimeout(() => {
      this.getCharges();
    }, 500);
  },
};
</script>
